<template>
  <div class="service-payment-status page">
    <div class="container">
      <div class="service-payment-status__inner">
        <payment-status :data="status" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, onBeforeUnmount, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import { 
  // REMITTAMCES_FROM_CARD, 
  REMITTAMCES_TO_CARD, 
  REMITTAMCES_TO_CARD_MERCHANT, 
  REMITTAMCES_TO_SIM, SERVICES, 
  STATUS_ERROR, 
  STATUS_PROCESS, 
STATUS_SUCCESS
} from '@/constant';

import PaymentStatus from '../PaymentStatus.vue';

export default defineComponent({
  components: {
    PaymentStatus
  },
  inheritAttrs: false,
  setup() {
    const store = useStore();
    const route = useRoute();
    const fetchStatus = ref(0);
    const showStatus = ref({});
    const language = computed(() => store.getters['language']);

    const data = ref({
      status: '',
      payment_id: '',
      paymentType: '',
      code:''
    });
    
    const timeToReques = ref({
      [SERVICES]: 15000,
      [REMITTAMCES_TO_SIM]: 3000,
      [REMITTAMCES_TO_CARD]: 3000
    });
    
    
        
    const paymentStatuses = ref({
      [SERVICES]: 'services/getServicesStatus',
      [REMITTAMCES_TO_SIM]: 'simRemittances/getStatusOfRemittancesToSim',
      [REMITTAMCES_TO_CARD]: 'cardRemittances/getStatusOfRemittancesToCard',
      [REMITTAMCES_TO_CARD_MERCHANT]: 'cardRemittancesMerchant/getStatusOfRemittancesToCard'
    });

    const status = ref({
      [SERVICES]: computed(() => store.getters['services/serviceStatus']),
      [REMITTAMCES_TO_SIM]: computed(() => store.getters['simRemittances/statusOfRemittancesToSim']),
      [REMITTAMCES_TO_CARD]: computed(() => store.getters['cardRemittances/remittancesToCardStatus']),
      [REMITTAMCES_TO_CARD_MERCHANT]:computed(() => store.getters['cardRemittancesMerchant/remittancesToCardStatus'])
    });

    const paymentInfo = ref({
      [SERVICES]: computed(() => store.getters['services/servicePaymentConfirm']?.payment),
      [REMITTAMCES_TO_SIM]: computed(() => store.getters['simRemittances/infoOfRemittancesToSim']?.payment),
      [REMITTAMCES_TO_CARD]: computed(() => store.getters['cardRemittances/remittancesToCardConfirm']?.payment),
      [REMITTAMCES_TO_CARD_MERCHANT]: computed(() => store.getters['cardRemittancesMerchant/remittancesToCardConfirm']?.payment)
    });

    const paymentData = computed(() => store.getters['paymentOtpData']);

        
    /**
     * ! status.value
     * ! разобраться этой ебалой
     */
    const getStatus = async () => {  
      if (
        data.value.status === STATUS_ERROR 
        || data.value.status === STATUS_SUCCESS
      ) {
        showStatus.value = { ...data.value };
        clearInterval(fetchStatus.value);
        return;
      }

      await store.dispatch(paymentStatuses.value[`${data.value.paymentType}`],{
        id: data.value.payment_id,
        language: language.value
      } );

      const currentStatus = status.value[`${data.value.paymentType}`];
      const check = Object.keys(currentStatus).length
          && currentStatus.payment 
          && currentStatus.payment.status 
          && currentStatus.payment.status !== STATUS_PROCESS;
      

      if (check) {
        const paymentIn = paymentInfo.value[`${data.value.paymentType}`];
        const failure_description = `Платеж №${currentStatus.payment.id} на ${currentStatus.payment.amount} ₸`;
        
        showStatus.value = { 
          ...currentStatus.payment,
          receipt_url: currentStatus.payment?.receipt_url 
            || paymentIn?.receipt_url 
            || '' ,
          code: data.value.code,
          failure_description
        };
        clearInterval(fetchStatus.value);
      }
      return;

    };
    
    onMounted(async () => {
      data.value = {
        ...paymentData.value
      }
      await getStatus();
      
      fetchStatus.value = setInterval(async() => {
        await getStatus();
      }, timeToReques.value[`${data.value.paymentType}`]);
    });

    onBeforeUnmount(() => {
      clearInterval(fetchStatus.value);
    });
    
    return {
      status: showStatus
    };
  },
});
</script>
